var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "exam-title exam-fill-item",
      class: { "group-text": _vm.itemsType },
      style: _vm.formatExamIndex,
    },
    [
      _vm.srcList && _vm.srcList.length > 0
        ? _c("el-image", {
            ref: "fillimage",
            staticClass: "elimage",
            attrs: { "preview-src-list": _vm.srcList },
          })
        : _vm._e(),
      _c(
        "el-popover",
        {
          ref: "popoverfill",
          attrs: {
            placement: "right",
            trigger: "hover",
            width: "200",
            disabled: !_vm.optionImg,
            "popper-options": {
              boundariesElement: "viewport",
              removeOnDestroy: true,
            },
          },
        },
        [
          _c(
            "el-image",
            { attrs: { src: _vm.dsf.url.getWebPath(_vm.optionImg) } },
            [
              _c(
                "div",
                {
                  staticClass: "image-slot",
                  attrs: { slot: "error" },
                  slot: "error",
                },
                [
                  _c("i", {
                    staticClass: "iconfont icon-tupianjiazaishibai err-img",
                  }),
                ]
              ),
            ]
          ),
        ],
        1
      ),
      _vm._l(_vm.htmls, function (item, index) {
        return [
          item != "—I—"
            ? [
                _c("div", {
                  directives: [
                    {
                      name: "popover",
                      rawName: "v-popover:popoverfill",
                      arg: "popoverfill",
                    },
                  ],
                  key: "title_" + index,
                  staticClass: "title",
                  domProps: { innerHTML: _vm._s(item) },
                  on: { click: _vm.showImage, mouseover: _vm.showPopver },
                }),
              ]
            : [
                _c("input", {
                  key: "input_" + index,
                  class: [
                    "exam-fill-input",
                    "exam-fill-part_input_" +
                      _vm.subjects.examQuestionsId +
                      "_" +
                      index,
                    _vm.previewStatus &&
                    _vm.readOnly &&
                    _vm.subjects.result &&
                    _vm.subjects.answer
                      ? _vm.fillValue["text_" + index] !==
                        _vm.subjects.newAnswer[index]
                        ? "error"
                        : ""
                      : "",
                  ],
                  attrs: {
                    readonly: _vm.readOnly,
                    name: index,
                    type: "text",
                    title: _vm.fillValue["text_" + index],
                    ondrop: "return false",
                  },
                  domProps: { value: _vm.fillValue["text_" + index] },
                  on: { input: _vm.changeVal },
                }),
                _vm.optionsScore["score_" + index]
                  ? _c("span", { key: "score_" + index, staticClass: "sub" }, [
                      _vm._v(
                        " （" +
                          _vm._s(
                            parseFloat(
                              _vm.optionsScore["score_" + index].toFixed(2)
                            )
                          ) +
                          "分）"
                      ),
                    ])
                  : _vm._e(),
              ],
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }